/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersIdGet200ResponseServicesInner model module.
 * @module model/CustomersIdGet200ResponseServicesInner
 * @version 1.0.0
 */
class CustomersIdGet200ResponseServicesInner {
    /**
     * Constructs a new <code>CustomersIdGet200ResponseServicesInner</code>.
     * @alias module:model/CustomersIdGet200ResponseServicesInner
     */
    constructor() { 
        
        CustomersIdGet200ResponseServicesInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersIdGet200ResponseServicesInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersIdGet200ResponseServicesInner} obj Optional instance to populate.
     * @return {module:model/CustomersIdGet200ResponseServicesInner} The populated <code>CustomersIdGet200ResponseServicesInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersIdGet200ResponseServicesInner();

            if (data.hasOwnProperty('lineIdentifier')) {
                obj['lineIdentifier'] = ApiClient.convertToType(data['lineIdentifier'], 'String');
            }
            if (data.hasOwnProperty('serviceLegacyId')) {
                obj['serviceLegacyId'] = ApiClient.convertToType(data['serviceLegacyId'], 'String');
            }
            if (data.hasOwnProperty('balances')) {
                obj['balances'] = ApiClient.convertToType(data['balances'], [Object]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersIdGet200ResponseServicesInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersIdGet200ResponseServicesInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['lineIdentifier'] && !(typeof data['lineIdentifier'] === 'string' || data['lineIdentifier'] instanceof String)) {
            throw new Error("Expected the field `lineIdentifier` to be a primitive type in the JSON string but got " + data['lineIdentifier']);
        }
        // ensure the json data is a string
        if (data['serviceLegacyId'] && !(typeof data['serviceLegacyId'] === 'string' || data['serviceLegacyId'] instanceof String)) {
            throw new Error("Expected the field `serviceLegacyId` to be a primitive type in the JSON string but got " + data['serviceLegacyId']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['balances'])) {
            throw new Error("Expected the field `balances` to be an array in the JSON data but got " + data['balances']);
        }

        return true;
    }


}



/**
 * @member {String} lineIdentifier
 */
CustomersIdGet200ResponseServicesInner.prototype['lineIdentifier'] = undefined;

/**
 * @member {String} serviceLegacyId
 */
CustomersIdGet200ResponseServicesInner.prototype['serviceLegacyId'] = undefined;

/**
 * @member {Array.<Object>} balances
 */
CustomersIdGet200ResponseServicesInner.prototype['balances'] = undefined;






export default CustomersIdGet200ResponseServicesInner;

